<template>
  <el-form label-width="110px" size="small">
    <!-- 需求：学历在最前，进路方向随学历变化 -->
    <el-form-item label="学历">
      <el-select
        v-model="path.eduBack"
        placeholder="请选择"
        clearable
        filterable
        style="width:100%"
        @change="onEduChange"
      >
        <el-option v-for="item in eduList" :key="item" :label="item" :value="item"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="进路方向（单选）" class="path-direction-item">
      <div v-if="!path.eduBack" class="path-direction-tip">请先选择学历</div>
      <el-radio-group
        v-else
        v-model="path.pathDirection"
        size="small"
        class="path-direction-group"
      >
        <el-radio-button
          v-for="item in filteredPathDirectionList"
          :key="item"
          :label="item"
        >{{ pathDirectionDisplay(item) }}</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <!-- 第一部分：就职 — 仅就职相关字段（客户已确认无问题，保持昨日顺序） -->
    <template v-if="isJob">
      <el-form-item label="日语成绩">
        <el-input v-model="path.japaneseScore" placeholder="请输入日语成绩"></el-input>
      </el-form-item>
      <el-form-item label="英语成绩">
        <el-input v-model="path.englishType" placeholder="请输入英语成绩"></el-input>
      </el-form-item>
      <el-form-item label="就职企业">
        <el-input v-model="path.enrollSchool" placeholder="请输入就职企业"></el-input>
      </el-form-item>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="企业类型">
            <el-select v-model="ext.companyType" placeholder="请选择" clearable style="width:100%">
              <el-option v-for="item in companyTypeList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="行业">
            <el-input v-model="ext.industry" placeholder="请输入行业"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="企业规模">
            <el-select v-model="ext.companyScale" placeholder="请选择" clearable style="width:100%">
              <el-option v-for="item in companyScaleList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="岗位">
            <el-input v-model="ext.position" placeholder="请输入岗位"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="大概年薪">
        <el-input v-model="ext.annualSalary" placeholder="请输入大概年薪"></el-input>
      </el-form-item>
      <el-form-item label="就职历程">
        <el-radio-group v-model="ext.jobPath">
          <el-radio v-for="item in jobPathList" :key="item" :label="item">{{ item }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="就职经验">
        <el-input type="textarea" :rows="3" v-model="ext.jobExperience" placeholder="请输入就职经验"></el-input>
      </el-form-item>
      <el-form-item label="入职时间">
        <el-date-picker v-model="ext.jobStartTime" type="month" value-format="yyyy-MM" format="yyyy-MM" placeholder="选择年月" style="width:100%"></el-date-picker>
      </el-form-item>
      <el-form-item label="其他/说明">
        <el-input type="textarea" :rows="2" v-model="ext.otherRemark" placeholder="其他说明（选填）"></el-input>
      </el-form-item>
    </template>

    <!-- 第二部分：非就职 — 统一升学字段与顺序 -->
    <template v-if="isNonJob">
      <el-form-item label="院校/大学院">
        <el-input v-model="path.enrollSchool" placeholder="请输入院校/大学院"></el-input>
      </el-form-item>
      <el-form-item label="专业/研究科">
        <el-input v-model="studyMajorModel" placeholder="请输入专业/研究科"></el-input>
      </el-form-item>
      <el-form-item v-if="showArtsScience" label="文理">
        <el-select v-model="path.artsScience" placeholder="请选择" clearable style="width:100%">
          <el-option v-for="item in artsScienceOptions" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日语成绩">
        <el-input v-model="path.japaneseScore" placeholder="请输入日语成绩"></el-input>
      </el-form-item>
      <el-form-item label="英语成绩">
        <el-input v-model="path.englishType" placeholder="请输入英语成绩"></el-input>
      </el-form-item>
      <el-form-item label="EJU分数">
        <el-input v-model="ext.ejuScore" placeholder="请输入EJU分数"></el-input>
      </el-form-item>
      <el-form-item label="校内考">
        <el-input type="textarea" :rows="2" v-model="path.internalExam" placeholder="请输入校内考"></el-input>
      </el-form-item>
      <el-form-item label="考学经验">
        <el-input type="textarea" :rows="3" v-model="path.examExperience" placeholder="请输入考学经验"></el-input>
      </el-form-item>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="合格时间">
            <el-date-picker v-model="path.eligibilityTime" type="month" value-format="yyyy-MM" format="yyyy-MM" placeholder="选择年月" style="width:100%"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="入学时间">
            <el-date-picker v-model="path.incomeDate" type="month" value-format="yyyy-MM" format="yyyy-MM" placeholder="选择年月" style="width:100%"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="入学方式">
        <el-radio-group v-model="ext.enrollMethod">
          <el-radio v-for="item in enrollMethodList" :key="item" :label="item">{{ item }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="其他/说明">
        <el-input
          v-if="isReturn"
          type="textarea"
          :rows="2"
          v-model="ext.returnReason"
          placeholder="回国原因或其他说明（选填）"
        ></el-input>
        <el-input
          v-else
          type="textarea"
          :rows="2"
          v-model="ext.otherRemark"
          placeholder="其他说明（选填）"
        ></el-input>
      </el-form-item>
    </template>
  </el-form>
</template>

<script>
import caseOptions from "@/plugins/caseOptions.js";

export default {
  name: "StudentCasePathForm",
  props: {
    path: { type: Object, required: true },
    ext: { type: Object, required: true },
    eduList: { type: Array, default: () => caseOptions.eduList },
    pathDirectionList: { type: Array, default: () => caseOptions.pathDirectionList }
  },
  data() {
    return {
      companyTypeList: caseOptions.companyTypeList,
      companyScaleList: caseOptions.companyScaleList,
      jobPathList: caseOptions.jobPathList,
      enrollMethodList: caseOptions.enrollMethodList,
      pd: caseOptions.pathDirection
    };
  },
  computed: {
    dir() { return this.path.pathDirection || ""; },
    filteredPathDirectionList() {
      return caseOptions.getPathDirectionsByEdu(this.path.eduBack);
    },
    /** 修士/预科/读博：专业写入研究科；其余写入入学专业 */
    studyMajorModel: {
      get() {
        if (this.isGradSchool) {
          return this.ext.researchDept || this.ext.specialization || this.path.enrollMajor || "";
        }
        return this.path.enrollMajor || "";
      },
      set(val) {
        this.path.enrollMajor = val;
        if (this.isGradSchool) {
          this.ext.researchDept = val;
          this.ext.specialization = val;
        }
      }
    },
    isXiuShi() { return this.dir === this.pd.xiuShi; },
    isPreparatory() { return this.dir === this.pd.preparatory; },
    isJob() { return this.dir === this.pd.job || this.dir === "就职"; },
    isReturn() { return this.dir === this.pd.returnHome; },
    isPhd() { return this.dir === this.pd.phd; },
    isGradSchool() {
      return this.isXiuShi || this.isPreparatory || this.isPhd;
    },
    /** 已选进路且非就职 → 第二部分升学字段 */
    isNonJob() {
      return !!this.dir && !this.isJob;
    },
    artsScienceOptions() {
      return caseOptions.getArtsScienceList(this.path.eduBack, this.path.pathDirection);
    },
    showArtsScience() {
      return this.artsScienceOptions.length > 0;
    }
  },
  watch: {
    "path.eduBack": {
      immediate: true,
      handler() {
        this.clearInvalidPathDirection();
        this.clearInvalidArtsScience();
      }
    },
    "path.pathDirection"() {
      this.clearInvalidPathDirection();
      this.clearInvalidArtsScience();
    }
  },
  methods: {
    pathDirectionDisplay(item) {
      if (caseOptions.pathDirectionDisplay) {
        return caseOptions.pathDirectionDisplay(item, this.path.eduBack);
      }
      return (caseOptions.pathDirectionLabel && caseOptions.pathDirectionLabel[item]) || item;
    },
    clearInvalidPathDirection() {
      // 专升本与编入同义，历史数据自动归并
      if (this.path.pathDirection === this.pd.zhuanShengBen) {
        this.path.pathDirection = this.pd.bianRu;
      }
      var allowed = caseOptions.getPathDirectionsByEdu(this.path.eduBack);
      if (this.path.pathDirection && allowed.indexOf(this.path.pathDirection) < 0) {
        this.path.pathDirection = "";
      }
    },
    clearInvalidArtsScience() {
      var opts = caseOptions.getArtsScienceList(this.path.eduBack, this.path.pathDirection);
      if (!opts.length) {
        this.path.artsScience = "";
        return;
      }
      if (this.path.artsScience && opts.indexOf(this.path.artsScience) < 0) {
        this.path.artsScience = "";
      }
    },
    onEduChange() {
      this.clearInvalidPathDirection();
      this.clearInvalidArtsScience();
    }
  }
};
</script>

<style scoped>
.path-direction-item {
  margin-bottom: 20px;
}
.path-direction-item >>> .el-form-item__label {
  line-height: 20px;
  padding-top: 10px;
}
.path-direction-item >>> .el-form-item__content {
  line-height: normal;
  padding-bottom: 16px;
  border-bottom: 1px solid #ebeef5;
}
.path-direction-tip {
  color: #909399;
  font-size: 13px;
  padding: 8px 0;
}
.path-direction-group {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  width: 100%;
}
.path-direction-group >>> .el-radio-button {
  margin: 0;
  width: 100%;
}
.path-direction-group >>> .el-radio-button__inner {
  width: 100%;
  min-height: 36px;
  padding: 8px 6px;
  line-height: 1.35;
  font-size: 13px;
  white-space: normal;
  border-radius: 4px !important;
  border: none !important;
  background: #f2f2f2;
  color: #333;
  box-shadow: none !important;
}
.path-direction-group >>> .el-radio-button__inner:hover {
  background: #e8e8e8;
  color: #333;
}
.path-direction-group >>> .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #5cb87a;
  border-color: transparent !important;
  color: #fff;
  box-shadow: none !important;
}
.path-direction-group >>> .el-radio-button__orig-radio:checked + .el-radio-button__inner:hover {
  background-color: #4fa86c;
  color: #fff;
}
</style>
